function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.164 10.584c-.522-.516-1.175-.516-1.694 0-.397.393-.793.786-1.182 1.185-.107.11-.197.133-.327.06-.256-.14-.529-.253-.775-.406-1.149-.722-2.111-1.651-2.964-2.697-.422-.52-.799-1.075-1.062-1.701-.053-.127-.043-.21.06-.313.396-.383.783-.776 1.172-1.169.543-.546.543-1.185-.003-1.734-.31-.313-.62-.62-.929-.933-.32-.32-.636-.642-.959-.958-.523-.51-1.175-.51-1.695.003-.4.393-.782.796-1.188 1.182-.376.356-.566.792-.606 1.302-.063.829.14 1.611.426 2.374.586 1.578 1.478 2.98 2.56 4.264a15.843 15.843 0 005.248 4.106c.918.446 1.87.789 2.906.845.713.04 1.332-.14 1.828-.695.34-.38.723-.726 1.082-1.09.533-.538.536-1.191.007-1.724a509.498 509.498 0 00-1.905-1.9zM11.528 7.93l1.229-.209a5.49 5.49 0 00-1.535-2.963 5.462 5.462 0 00-3.13-1.562L7.92 4.432c.922.13 1.761.546 2.424 1.208a4.236 4.236 0 011.185 2.29zM13.45 2.59A9.059 9.059 0 008.254 0l-.173 1.235a7.855 7.855 0 014.488 2.238 7.849 7.849 0 012.201 4.245L16 7.508a9.126 9.126 0 00-2.55-4.918z"
});

function SvgPhoneCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    stroke: "currentColor"
  }, props), _ref);
}

export default SvgPhoneCall;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/phoneCall.svg
// module id = 1305
// module chunks = 10